import React from 'react';
import PropTypes from 'prop-types';
import './Overlay.css';
import xIcon from 'assets/icons/overlay-x.svg';
import lealHealthIcon from 'assets/logo_new.svg';

const Overlay = (props) => {
  const {
    children, onclose, className, hideCloseButton, hideTop,
  } = props;
  return (
    <div className={`overlay ${className || ''}`}>
      {
        !hideTop ? (
          <div className="overlay-top">
        <div className="logo-pos">
          <img
            alt="arrow button"
            src={lealHealthIcon}
            style={{
            }}
          />
        </div>
        {
          hideCloseButton ? <></> : (
            <div className="overlay-close" onClick={onclose}>
              <img alt="close" src={xIcon} />
            </div>
          )
        }

      </div>
        ) : null
      }
      <div className="overlay-main">
        {children}
      </div>
    </div>
  );
};

Overlay.propTypes = {
  children: PropTypes.any,
  onclose: PropTypes.func,
  className: PropTypes.string,
};

export default Overlay;
